import { AdmissionMapTranslations } from "../models/admission-map-translaction-model";

export const enUS: AdmissionMapTranslations = {
  title: 'Report - Admission Map',
  tabs: {
    admission: 'Map',
    reports: 'My Reports',
  },
  status: {
    changesSaved: 'Changes saved',
  },
  reports: {
    layoutName: 'Procedure Report',
  },
  fields: {
    carrier: 'Carrier',
    contract: 'Contract',
    patient: 'Patient',
    passwordStatus: 'Authorization Status',
    cidCode: 'ICD',
    cidDescription: 'ICD Description',
    speciality: 'Speciality',
    urgencyType: 'Urgency / Elective',
    highCost: 'High Cost',
    unauthorized: 'Eligible companion',
    icu: 'ICU',
    medicalReport: 'Medical Report',
    specialCase: 'Special Case',
    evolution: 'Evolution',
    note: 'Note',
    financialGroup: 'Financial Group',
    startPeriod: 'Start Period',
    endPeriod: 'End Period',
  },
  filter: {
    withHistory: 'With Record History',
    expandSearch: 'Expand Search Options',
    clear: 'Clear Filters',
    placeholders: {
      select: 'Select',
      startDate: 'Start date',
      endDate: 'End date',
    },
  },
  actions: {
    export: 'Export',
    viewHistory: 'View History',
  },
  table: {
    noData: 'No records found for the selected filters.',
    headers: {
      note: 'Notes',
    },
  },
  dialog: {
    editObservationTitle: 'Edit observation',
  },
  messages: {
    exportError: 'Error exporting admission map',
    groupsError: 'Error fetching financial groups',
    carriersError: 'Error fetching carriers',
    contractsError: 'Error fetching contracts',
    passwordStatusesError: 'Error fetching authorization statuses',
    urgencyTypesError: 'Error fetching urgency types',
    highCostTypesError: 'Error fetching high cost types',
    searchError: 'Error fetching admission map',
    historyError: 'Error fetching admission history',
    updateError: 'Error updating admission map',
    noPermission: 'You do not have permission to perform this action.',
    noPermissionTop: 'No permission',
    saveError: 'Unable to save your changes. Check your internet connection and try again.',
    noDataText: 'No data found.',
    loadingText: 'Loading...',
    noResultText: 'No result found.',
    notSpecified: 'Not specified',
    validationFields: {
      note: 'The field "Note" is required',
      companionAuthorized: 'The field "Eligible companion" is required',
      evolution: 'The field "Evolution" is required',
      specialCase: 'The field "Special case" is required',
      highCost: 'The field "High cost" is required',
      cidDescription: 'The field "ICD description" is required',
      urgencyType: 'The field "Urgency type" is required',
      uti: 'the field "ICU" is required',
      speciality: 'The field "Speciality" is required',
    },
  },
  passwordStatuses: {
    authorized: 'Authorized',
    released: 'Released',
    denied: 'Denied',
    pending: 'Pending',
    canceled: 'Canceled',
    analysis: 'Analysis',
  },
  boolean: {
    yes: 'Yes',
    no: 'No',
  },
  history: {
    types: {
      added: 'Added',
      updated: 'Updated',
      deleted: 'Deleted',
    },
  },
};